<template>
  <div
    class="vocation-cop"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="content" @click="toDetail">
        <div class="con-le">
          <div class="tit">{{ dataInfo.tips }}</div>
          <div class="cope">
            {{ dataInfo.name }}
            <img
              class="voc-logo vm"
              src="../../../assets/img/vocation-hbt.png"
              alt=""
            />
            <img class="vm" :src="dataInfo.icon" alt="" />
          </div>
          <div class="con">
            {{ contentInfo.tips }}
          </div>
          <div class="con-bot">
            <div class="t1">·{{ contentInfo.title }}</div>
            <div class="t1 pt-10">·{{ contentInfo.subtitle }}</div>
          </div>
        </div>
        <div class="con-ri">
          <img class="img" :src="contentInfo.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      contentInfo: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    this.dataInfo = dataInfo;
  },
  methods: {
    toDetail() {
      this.toUrl(this.contentInfo.url);
    }
  }
};
</script>
<style lang="less">
.vocation-cop {
  padding-top: 164px;
  padding-bottom: 210px;
  width: 100%;
  height: 860px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .content {
    display: flex;
    cursor: pointer;
    .con-le {
      margin-right: 100px;
      .tit {
        font-size: 72px;
        font-family: "en-tit";
        color: #fff;
        line-height: 87px;
      }
      .cope {
        font-size: 48px;
        font-family: Dream-LiHeiGB, Dream;
        color: #fff;
        line-height: 54px;
      }
      .vm {
        vertical-align: middle;
      }
      .voc-logo {
        margin-left: 32px;
        margin-right: 25px;
      }
      .con {
        padding-top: 40px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        line-height: 36px;
        width: 560px;
        box-sizing: border-box;
      }
      .t1 {
        font-size: 28px;
        font-weight: 600;
        color: #fff;
      }
      .pt-10 {
        padding-top: 10px;
      }
      .con-bot {
        padding-top: 48px;
      }
    }
    .con-ri {
      .img {
        width: 540px;
        height: 370px;
        border-radius: 24px;
      }
    }
  }
}
</style>
